import Axios from "axios";
import { facilityPricingParameterUrls } from "../urls";
import router from "../../../router";

export default {
  get_facility_pricing_parameter(context, publicId) {
    Axios.get(
      facilityPricingParameterUrls.getFacilityPricingParameter + publicId
    )
      .then(function(response) {
        context.commit("GET_FACILITY_PRICING_PARAMETER", response.data);
      })
      .catch(function() {
        context.commit("UPDATE_ERRORS", { data: [] });
      });
  },
  get_priced_facility_parameter(context, publicId) {
    Axios.get(
      facilityPricingParameterUrls.getPricedFacilityParameter + publicId
    )
      .then(function(response) {
        context.commit("GET_PRICED_FACILITY_PARAMETER", response.data);
      })
      .catch(function() {
        context.commit("UPDATE_ERRORS", { data: [] });
      });
  },
  post_facility_pricing_parameter(context, data) {
    Axios.post(facilityPricingParameterUrls.postFacilityParameter, data)
      .then(function() {
        context.dispatch("get_facility_pricing_parameter", data.facility_id);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  edit_facility_pricing_parameter(context, data) {
    Axios.patch(facilityPricingParameterUrls.alterFacilityParameter, data).then(
      function(response) {
        context.dispatch("get_facility_pricing_parameter", data.facility_id);
      }
    );
  },
  delete_a_facility_pricing_parameter(context, data) {
    Axios.post(
      facilityPricingParameterUrls.deleteFacilityPricingParameter +
        data.public_id,
      data
    ).then(function(response) {
      context.commit("GET_DELETED_FACILITY_PRICING_PARAMETER", response.data);
      context.dispatch("get_facility_pricing_parameter", data.facility_id);
    });
  }
};
